import { Component, Input, OnInit } from '@angular/core';
import { PageFooterResponseJSON } from "./../common/JSON/surveyFooter/Page-Footer-Response-JSON";

@Component({
  selector: 'altSurvey-footer',
  templateUrl: './Footer.component.html'
})
export class FooterComponent implements OnInit {

  @Input() pageFooterResponseJSON: PageFooterResponseJSON;

  constructor() { }

  ngOnInit() {
  }

}